import att from '@/api/attendance-device'
import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  edit_data: {}
}

export const mutations = {
  ...baseMutations
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search
      },
      attrubutes
    )
    return att.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },

  store(context, data) {
    return att.store(data)
  },

  update(context, { id, data }) {
    return att.update(id, data)
  },
  async find(context, id) {
    if (_.isEmpty(context.state.edit_data)) {
      let response = await att.find(id)
      context.commit('SET_EDIT_DATA', response.data)
    }
  },

  getAttendanceType(context) {
    return att.getAttendanceType()
  }
}
